import LivePage from "./LivePage";

export default LivePage;
